import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../app/hooks';

import { isSuperUser } from '../../../utils/userPermissions';

export const useIsSuperUser = () => {
  const [isSuperUserStatus, setIsSuperUserStatus] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!user) setIsSuperUserStatus(false);
    else setIsSuperUserStatus(isSuperUser(user.role));
  }, [user]);

  return isSuperUserStatus;
};
